var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwnerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0003 20.1667C26.0504 20.1667 29.3337 16.8834 29.3337 12.8333C29.3337 8.78325 26.0504 5.5 22.0003 5.5C17.9502 5.5 14.667 8.78325 14.667 12.8333C14.667 16.8834 17.9502 20.1667 22.0003 20.1667Z",
    stroke: "#121212",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 38.5V34.8333C11 32.8884 11.7726 31.0232 13.1479 29.6479C14.5232 28.2726 16.3884 27.5 18.3333 27.5H25.6667C27.6116 27.5 29.4768 28.2726 30.8521 29.6479C32.2274 31.0232 33 32.8884 33 34.8333V38.5",
    stroke: "#121212",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerIcon);
export default __webpack_public_path__ + "static/media/owner-icon.a7df7fa50c9bdfd4526756b2027f1feb.svg";
export { ForwardRef as ReactComponent };